import {BaseConverter} from "../../base/converters/base-converter.converter";
import {EobiErrorModel} from "../models/eobi-error.model";
import {EobiError} from "../DTO/eobiError";
import {Injectable} from "@angular/core";
import {ExternalErrorConverter} from "./external-error.converter";

@Injectable()
export class EobiErrorConverter extends BaseConverter<EobiErrorModel, EobiError> {

  constructor(private externalErrorConverter: ExternalErrorConverter) {
    super();
  }

  convertToDto(model: EobiErrorModel): EobiError {
    if (!model) {
      return;
    }
    return {
      code: model.code,
      extraCode: model.extraCode,
      extraField: model.extraField,
      extraMessage: model.extraMessage,
      message: model.message,
      externalErrors: this.externalErrorConverter.convertToDtoList(model.externalErrors)
    };
  }

  convertToModel(dto: EobiError): EobiErrorModel {
    if (!dto) {
      return null;
    }
    let model: EobiErrorModel = new EobiErrorModel();
    model.externalErrors = this.externalErrorConverter.convertToModelList(dto.externalErrors);
    model.message = dto.message;
    model.extraMessage = dto.extraMessage;
    model.extraField = dto.extraField;
    model.extraCode = dto.extraCode;
    model.code = dto.code;
    return model;
  }

}
